import { useTranslation } from "react-i18next";

import { Text } from "@fragments";

import "./styles.scss";

export default function PresetsSidebar({ presets, activeId, onPick }) {
    const { t } = useTranslation("fragments");

    return (
        <ul className="dpi-presets">
            {presets.map((p) => {
                const isActive = p.id === activeId;
                // Built-in presets carry a `labelKey`; caller-supplied ones keep
                // a ready-made `label`.
                const label = p.label ?? (p.labelKey ? t(p.labelKey) : "");
                return (
                    <li key={p.id}>
                        <button
                            type="button"
                            className={`dpi-presets__item ${isActive ? "is-active" : ""}`}
                            onClick={() => onPick(p.id)}
                        >
                            <Text.span contrast={isActive ? 1 : 8}>
                                {label}
                            </Text.span>
                        </button>
                    </li>
                );
            })}
        </ul>
    );
}
